






































































import { typedStore, Actions } from '@/store';
import { collapseMixin } from '@/shared';
import Vue from 'vue';
import mixins from 'vue-typed-mixins';
import { AchievementType } from '@/models';
import { EditAchievementModal, DeleteAchievementModal } from '@/components';

export default mixins(collapseMixin).extend({
  name: 'AchievementTypesTab',
  components: {
    EditAchievementModal,
    DeleteAchievementModal,
  },
  data() {
    return {
      loader: {
        isAchievementTypesListFetching: false,
      },
      editedAchievement: undefined as unknown as AchievementType,
      deletedAchievement: undefined as unknown as AchievementType,
    };
  },
  async created(): Promise<void> {
    await this.fetchAchievements();
  },
  computed: {
    allAchievements(): AchievementType[] {
      return typedStore(this).state.achievements.allAchievements;
    },
  },
  methods: {
    async editAchievementType(achievementType: AchievementType) {
      this.editedAchievement = achievementType;
      this.$bvModal.show('edit-achievement-modal');
    },
    async deleteAchievementType(achievementType: AchievementType) {
      if (achievementType.isGranted) {
        return;
      }

      this.deletedAchievement = achievementType;
      this.$bvModal.show('delete-achievement-modal');
    },
    async fetchAchievements() {
      this.loader.isAchievementTypesListFetching = true;

      try {
        await this.$store.dispatch(Actions.achievements.fetchAllAchievements);
      } finally {
        this.loader.isAchievementTypesListFetching = false;
      }
    },
  },
});
